export const PrivacyAdmobAndRevenueCat = () => {
    return (
        <div className="policy">
            <h1>Privacy Policy</h1>
            <p className="updated">Last updated: March 2026</p>

            <p>
                Thank you for using <strong>Body Timeline</strong>. This Privacy Policy
                explains how information is handled when you use our application.
            </p>

            <h2>Information We Collect</h2>
            <p>
                Body Timeline does not require user registration and does not collect
                personal information such as your name, email address, or contacts.
            </p>

            <p>
                Photos taken within the app are stored locally on your device and are
                not transmitted to our servers.
            </p>

            <h2>Advertising</h2>

            <p>
                This app uses <strong>Google AdMob</strong> to display advertisements.
            </p>

            <p>
                AdMob may automatically collect certain information in order to display
                and improve advertisements, including:
            </p>

            <ul>
                <li>Device information</li>
                <li>Advertising identifiers</li>
                <li>IP address</li>
                <li>Ad interaction data</li>
            </ul>

            <p>
                This data is collected and processed by Google according to their
                privacy policy.
            </p>

            <p>
                More information:
                <br />
                <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://policies.google.com/privacy
                </a>
            </p>

            <h2>In-App Purchases</h2>

            <p>
                Body Timeline offers optional in-app purchases that unlock premium
                features.
            </p>

            <p>
                Purchases are processed through the Apple App Store or Google Play.
            </p>

            <p>
                We use <strong>RevenueCat</strong> to manage subscription and purchase
                status. RevenueCat may process limited purchase-related data such as:
            </p>

            <ul>
                <li>Anonymous user identifiers</li>
                <li>Purchase status</li>
                <li>Subscription information</li>
            </ul>

            <p>
                This information is used only to verify purchase entitlements and manage
                premium features.
            </p>

            <p>
                More information:
                <br />
                <a
                    href="https://www.revenuecat.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.revenuecat.com/privacy
                </a>
            </p>

            <h2>Data Sharing</h2>

            <p>
                We do not sell or share personal information with third parties.
                However, third-party services such as Google AdMob and RevenueCat may
                process data according to their own privacy policies.
            </p>

            <h2>Children's Privacy</h2>

            <p>
                This app is not directed to children under the age of 13. We do not
                knowingly collect personal information from children.
            </p>

            <h2>Changes to This Privacy Policy</h2>

            <p>
                We may update this Privacy Policy from time to time. Any updates will be
                posted on this page with an updated revision date.
            </p>

            <h2>Contact</h2>

            <p>
                If you have any questions about this Privacy Policy, please contact us:
            </p>

            <p>Email: admin@arrghsoft.com</p>
        </div>
    );
};